const KEY = 'pending-parking-purchase';

export function savePendingParkingPurchase() {
	localStorage.setItem(KEY, 'true');
}

export function getPendingParkingPurchase(): boolean {
	return localStorage.getItem(KEY) === 'true';
}

export function clearPendingParkingPurchase() {
	localStorage.removeItem(KEY);
}
